export default "__VITE_ASSET__DoLv5s1H__"